module.exports = __webpack_public_path__ + "static/media/icon-date-seeker-new.50a1d1ab.svg";